module.exports = __webpack_public_path__ + "img/background.c9d16a96.jpg";